export interface TileSizeConfig {
  width: number;
  height: number;
}

const SMALL: TileSizeConfig = {
  width: 208,
  height: 117,
};

const MID: TileSizeConfig = {
  width: 265,
  height: 149,
};

const LARGE: TileSizeConfig = {
  width: 360,
  height: 202,
};

const APP: TileSizeConfig = {
  width: 75,
  height: 75,
};

const WIDE_APP: TileSizeConfig = {
  width: 98,
  height: 54,
};

export const CoreTileConfig = {
  SMALL,
  MID,
  LARGE,
  APP,
  WIDE_APP,
};

export const TILE_GAP = 20;
export const VERTICAL_PADDING = 20;

export const tileWidth = CoreTileConfig.MID.width;
export const tileHeight = CoreTileConfig.MID.height;
